// Datos estáticos del blog separados para mejor mantenimiento
const temas = [
  {
    id: "alimentacion",
    titulo: "Alimentación",
    descripcion:
      "Consejos y recetas de platos saludables para nutrir tu cuerpo y mantener hábitos equilibrados.",
    posts: [
      { title: "Alimentación Saludable", img: "/images/blog/alimento1.webp", excerpt: "Consejos y pautas para llevar una alimentación equilibrada y nutritiva." },
      { title: "Desayunos Saludables", img: "/images/blog/alimento2.webp", excerpt: "Opciones de desayunos rápidos, ricos y saludables para empezar bien el día." },
      { title: "Horarios de las Comidas", img: "/images/blog/alimento3.webp", excerpt: "Aprende cuándo y cómo organizar tus comidas para mantener energía todo el día." },
      { title: "Macronutrientes y Cómo Identificarlos", img: "/images/blog/alimento4.webp", excerpt: "Guía para reconocer proteínas, carbohidratos y grasas en tus alimentos." },
      { title: "Collage Desayuno y Almuerzo 1", img: "/images/blog/alimento5.webp", excerpt: "Ideas visuales y ejemplos de combinaciones saludables para desayuno y almuerzo." },
      { title: "Collage Desayuno y Almuerzo 2", img: "/images/blog/alimento6.webp", excerpt: "Más ejemplos de platos coloridos y nutritivos para inspirarte a comer mejor." },
      { title: "Collage Desayuno y Almuerzo 3", img: "/images/blog/alimento7.webp", excerpt: "Opciones finales de combinaciones saludables para desayuno y almuerzo." }
    ]
  },
  {
    id: "rutinas",
    titulo: "Rutinas de Entrenamiento",
    descripcion:
      "Rutinas sencillas para principiantes que podés hacer en casa sin equipo complicado.",
    posts: [
      { title: "Rutina de Ejercicios Sencilla", img: "/images/blog/rutina1.webp", excerpt: "Una rutina simple para activar tu cuerpo y empezar el día con energía." },
      { title: "Rutina de 4 Días", img: "/images/blog/rutina2.webp", excerpt: "Programa completo de 4 días para tonificar y fortalecer tus músculos." },
      { title: "4 Ejercicios para la Casa", img: "/images/blog/rutina3.webp", excerpt: "Ejercicios prácticos y efectivos que podés realizar sin equipamiento." },
      { title: "Comenzar a Hacer Deporte", img: "/images/blog/tips5.webp", excerpt: "Recomendaciones para iniciar tu rutina deportiva sin estrés." }
    ]
  },
  {
    id: "tips",
    titulo: "Tips y Motivación",
    descripcion:
      "Consejos prácticos, frases motivacionales y tips para mantener tu constancia y actitud positiva.",
    posts: [
      { title: "Perder Peso", img: "/images/blog/tips1.webp", excerpt: "Consejos prácticos y sencillos para adelgazar de forma saludable." },
      { title: "Mitos sobre el Ejercicio", img: "/images/blog/tips2.webp", excerpt: "Desmentimos las ideas equivocadas más comunes sobre entrenar." },
      { title: "La Fuerza Interior", img: "/images/blog/tips3.webp", excerpt: "Pequeños recordatorios diarios que te inspiran a seguir adelante." },
      { title: "Cuidate a tí mismo", img: "/images/blog/tips4.webp", excerpt: "Reflexiones para tomar decisiones más saludables en tu vida." }
    ]
  }
];

export default temas;
